var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-base",class:[
    { primary: !_vm.secondary && !_vm.borderless },
    { secondary: _vm.secondary },
    { borderless: _vm.borderless },
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }